import styled from 'styled-components';
import Task from './component';

export default styled(Task)`
  display: flex;
  height: 33px;
  align-items: center;
  padding: 0 8px;
  justify-content: space-between;
  position: relative;

  &:after {
    position: absolute;
    height: 1px;
    left: 40px;
    right: 8px;
    bottom: 0;
    background: var(--grey300);
    content: '';
  }

  .group {
    display: flex;

    &__status-field {
      margin-right: 8px;
      display: flex;
      align-items: center;
    }
  }
`;
